import { JobListing, JobApplication, PaginatedResponse } from '../types';
import apiService from './api';

export class JobService {
  async getAllJobs(
    page: number = 0,
    size: number = 10,
    sort?: string,
    filters?: any
  ): Promise<PaginatedResponse<JobListing>> {
    return apiService.getPaginated<JobListing>('/api/jobs/admin/all', page, size, sort, filters);
  }

  async getJobById(id: string): Promise<JobListing> {
    return apiService.get<JobListing>(`/api/jobs/${id}`);
  }

  async createJob(jobData: Partial<JobListing>): Promise<JobListing> {
    return apiService.post<JobListing>('/api/jobs', jobData);
  }

  async updateJob(id: string, jobData: Partial<JobListing>): Promise<JobListing> {
    return apiService.put<JobListing>(`/api/jobs/${id}`, jobData);
  }

  async deleteJob(id: string): Promise<void> {
    await apiService.delete(`/api/jobs/${id}`);
  }

  async getJobApplications(jobId: string): Promise<JobApplication[]> {
    return apiService.get<JobApplication[]>(`/api/jobs/${jobId}/applications`);
  }

  async updateApplicationStatus(applicationId: string, status: string): Promise<void> {
    await apiService.put(`/api/jobs/applications/${applicationId}`, { status });
  }

  async getAllApplications(
    page: number = 0,
    size: number = 10,
    sort?: string,
    filters?: any
  ): Promise<PaginatedResponse<JobApplication>> {
    return apiService.getPaginated<JobApplication>(
      '/api/jobs/applications',
      page,
      size,
      sort,
      filters
    );
  }
}

export const jobService = new JobService();
export default jobService;
